/**
 * Utility functions for the TimePicker component
 */

import {
  secondsToTime12Hour,
  time12HourToSeconds,
} from "common/utils/timesheet";
import { DEFAULT_VALUES } from "./constants";

export { secondsToTime12Hour as getInputValuesFromTime };

/**
 * Create a time value from partial input values, using defaults for missing values
 * @param {Object} params - Object containing hour, minute, period values
 * @returns {number} Time in seconds since midnight
 */
export const createTimeFromPartialInputs = ({ hour, minute, period }) => {
  const hourValue = hour ? parseInt(hour) : DEFAULT_VALUES.HOUR;
  const minuteValue = minute ? parseInt(minute) : DEFAULT_VALUES.MINUTE;
  const periodValue = period || DEFAULT_VALUES.PERIOD;

  return time12HourToSeconds(hourValue, minuteValue, periodValue);
};

/**
 * Create a change handler for a specific field
 * @param {Object} currentValues - Current display values
 * @param {Function} onChange - Parent onChange callback
 * @param {string} fieldName - Name of the field being changed
 * @returns {Function} Change handler function
 */
export const createFieldChangeHandler = (
  currentValues,
  onChange,
  fieldName
) => {
  return (_e, selectedValue) => {
    const newValues = {
      hour: currentValues.hour,
      minute: currentValues.minute,
      period: currentValues.period,
      [fieldName]: selectedValue,
    };

    const newTime = createTimeFromPartialInputs(newValues);
    onChange(newTime);
  };
};
